import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IWithdrawOtpState {
  isOpen: boolean
  challengeId: string | null
  ttlSeconds: number | null
  isLoading: boolean
}

const initialState: IWithdrawOtpState = {
  isOpen: false,
  challengeId: null,
  ttlSeconds: null,
  isLoading: false,
}

export const withdrawOtpSlice = createSlice({
  name: 'withdrawOtp',
  initialState,
  reducers: {
    openOtpModal: (state, action: PayloadAction<{ challengeId: string; ttlSeconds: number }>) => {
      state.isOpen = true
      state.challengeId = action.payload.challengeId
      state.ttlSeconds = action.payload.ttlSeconds
      state.isLoading = false
    },
    closeOtpModal: (state) => {
      state.isOpen = false
      state.challengeId = null
      state.ttlSeconds = null
      state.isLoading = false
    },
    setOtpLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
  },
})

export const { openOtpModal, closeOtpModal, setOtpLoading } = withdrawOtpSlice.actions

export default withdrawOtpSlice.reducer
